import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { IApplicationState } from '../../store/applicationState';
import { getMessageThread } from '../../services/messages';
import { fetchGroup } from '../../store/group/groupActions';
import { IGroup, IGroupMember } from '../../store/group/groupState';

import ActivityList from '../../components/shared/activitylist/ActivityList';
import Message, { DisplayMode } from '../../components/shared/message/Message';
import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';

import * as helper from '../../genericExtensions';

export interface IMessageThreadRouterParams {
    groupId: string;
    threadId: string;
}

interface IState {
    cancelToken: CancelTokenSource;
    threadMessages?: any[];
    hasLoadedThread: boolean;
}

interface IStateProps {
    group: IGroup;
    groupMembers: IGroupMember[];
    viewerIsDi: boolean;
}

interface IDispatchProps {
    fetchGroup: typeof fetchGroup;
}

type Props = IStateProps & IDispatchProps & RouteComponentProps<IMessageThreadRouterParams>;

class MessageThreadIndex extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            cancelToken: axios.CancelToken.source(),
            hasLoadedThread: false
        };
    }

    public async componentDidMount() {
        if (this.props.group) {
            const threadMessages = await getMessageThread(this.props.match.params.groupId, this.props.match.params.threadId, this.state.cancelToken);

            this.setState({
                threadMessages,
                hasLoadedThread: true
            });
        } else {
            this.props.fetchGroup(this.props.match.params.groupId, this.state.cancelToken);
        }
    }

    public async componentDidUpdate(prevProps: Props) {
        if (prevProps.group !== this.props.group) {
            await this.loadMessages();
        }
    }

    public componentWillUnmount() {
        this.state.cancelToken.cancel();
    }

    public render() {
        return <React.Fragment>
            <div className="section">
                <div className="deck">
                    <div className="w--md banner-title">
                        <h1>Beskeder og dokumenter</h1>
                    </div>
                </div>
                <div className="deck">
                    <div className="w--md">
                        {this.state.threadMessages && this.state.threadMessages.length ?
                            <ActivityList>
                                {this.state.threadMessages.map((m, index: number) =>
                                    <Message message={m} displayMode={DisplayMode.Full} group={this.props.group} groupMembers={this.props.groupMembers} index={index} key={m.messageId} isDisconnected={true} isDi={this.props.viewerIsDi} onDeleted={this.loadMessages} />)
                                }
                            </ActivityList>
                            :
                            !this.state.hasLoadedThread ?
                                <Spinner size={SpinnerSize.Large} />
                                : 
                                <Redirect to={`/Group/${this.props.match.params.groupId}`} />
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }

    private loadMessages = async () => {
        const threadMessages = await getMessageThread(this.props.match.params.groupId, this.props.match.params.threadId, this.state.cancelToken);

        this.setState({ threadMessages });
    }
}

const mapStateToProps = (state: IApplicationState, ownProps: RouteComponentProps<IMessageThreadRouterParams>): IStateProps => {
    const urlGroupId = ownProps.match.params.groupId;
    const potentialGroupIds = state.groupData.groups.groups.allIds.filter(id => {
        const g = state.groupData.groups.groups.byId[id];

        return g.alias === urlGroupId || g.id === urlGroupId;
    });
    const groupId = (potentialGroupIds.length && potentialGroupIds[0]) || urlGroupId;
    const group = state.groupData.groups.groups.byId[groupId];
    const groupMembers = state.groupData.members.byId[groupId] && state.groupData.members.byId[groupId].members && helper.all(state.groupData.members.byId[groupId].members);
    const viewerIsDi = state.oidc.user.profile.role === 'DI';

    return { group, groupMembers, viewerIsDi };
}

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    fetchGroup: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroup(groupId, cancelToken))
});

const container = withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageThreadIndex));

export default container;